var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dashboard-stats"},_vm._l((_vm.lines),function(ref,i){
var name = ref.name;
var count = ref.count;
var all = ref.all;
var color = ref.color;
return _c('div',{key:i,staticClass:"dashboard-stats__row"},[_c('div',{staticClass:"dashboard-stats__head"},[_c('div',{staticClass:"dashboard-stats__title"},[_vm._v(_vm._s(name))]),_c('div',{staticClass:"dashboard-stats__count"},[_vm._v(_vm._s(count)+"/"+_vm._s(all))])]),_c('div',{staticClass:"dashboard-stats__line"},[_c('div',{staticClass:"dashboard-stats__val",style:(_vm.getStyle(count, all, color))})])])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }